export default "__VITE_ASSET__BZt2CiLP__"